import { render } from "./AdminNav.vue?vue&type=template&id=c10a1b36&scoped=true"
import script from "./AdminNav.vue?vue&type=script&lang=js"
export * from "./AdminNav.vue?vue&type=script&lang=js"

import "./AdminNav.vue?vue&type=style&index=0&id=c10a1b36&scoped=true&lang=css"

import exportComponent from "/Users/cageyoshida/sourcecodes/lotw-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c10a1b36"]])

export default __exports__